
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/herkunft",
      function () {
        return require("private-next-pages/herkunft/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/herkunft"])
      });
    }
  